export default "__VITE_ASSET__DkwQU6aU__"